export default __webpack_public_path__ + "static/media/instructions_close.0707f3a8.svg";